export * from './b64-to-canvas.directive';



// WEBPACK FOOTER //
// ./src/app/directives/b64-to-canvas/index.ts